import React from "react";

const experienceContent = [
  {
    year: "  May 2020 - Present",
    position: " Team Lead",
    compnayName: "i-TechnoLabs Solutions Pvt. Ltd",
    details: [
      "• Directly lead a team of 10+ engineers, conducting code reviews and defining technical roadmaps for global-scale applications",
      "• Architected a robust microservices ecosystem with Docker and AWS, reducing deployment time by 30% and significantly enhancing scalability",
      "• Spearheaded the integration of GenAI models (Gemini, OpenAI) into core products, automating data processing and reducing manual workload by 60%",
    ]
  },
  {
    year: "  May 2019 - May 2020",
    position: " Sr. Software Developer",
    compnayName: "YapApp India Pvt. Ltd",
    details: [
      "• Developed high-performance REST APIs using Node.js and Express, consistently supporting 50,000+ concurrent users",
      "• Optimized MySQL and MongoDB database schemas, reducing query latency by 35% for data-intensive applications",
      "• Managed cloud infrastructure on AWS, specifically leveraging EC2 for compute and S3 for scalable asset storage",
    ]
  },
  {
    year: "  May 2018 - Apr 2019",
    position: " Jr. Software Developer",
    compnayName: "DuskByte",
    details: [
      "• Developed and deployed dynamic web applications using Laravel and JavaScript, consistently meeting client deliverables ahead of schedule",
      "• Collaborated with agile teams to launch 2+ innovative web products, strictly adhering to best coding practices",
      "• Payment gateway integrations (Stripe), securely processing high-volume transactions and display sales analytics",
    ]
  },
  {
    year: "  Jan 2017 - Apr 2018",
    position: " Jr. Software Developer",
    compnayName: "Logic Providers",
    details: [
      "• Built and maintained responsive frontend interfaces using HTML, CSS, and jQuery, ensuring 100% cross-browser compatibility",
      "• Assisted in backend API development, reducing server response time by 20% through the code optimization",
    ]
  }
];

const Experience = () => {
  return (
    <ul>
      {experienceContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font">{val.year}</span>
          <h5 className="poppins-font">
            {val.position}
            <span className="place open-sans-font">{val.compnayName}</span>
          </h5>
          {val?.details?.length && val.details.map((item, i) => (
            <p className="open-sans-font">{item}</p>
          ))}
        </li>
      ))}
    </ul>
  );
};

export default Experience;
